import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user/user.service';

export const authGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const isAuthorized = await userService.isAuthorized();
  if (isAuthorized) {
    return true;
  }

  userService.logout();
  return router.createUrlTree(['/login']);
};
